<style >
.content-spin {
  width: 100%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  z-index: -2;
  float: none;
  box-sizing: content-box;
}

.spin {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 5px solid rgb(18, 146, 14);
  background: transparent;
  border-top-color: #efef;
  border-bottom-color: #efef;
  border-left-color: rgb(41, 167, 16);
  animation: spin 1.5s linear infinite;
  position: relative;
}

@keyframes spin {
  0% {
    background: transparent;
    transform: rotate(720deg);
  }
}
</style>
<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->
    <div class="controls-above-table">
      <div class="form-inline">
        <input
          class="form-control form-control-sm rounded bright"
          placeholder="Search"
          v-model="searchtext"
          type="text"
          style="width: 500px"
          v-on:keyup.enter="filterData"
        />
        <div class="input-group-append">
          <button
            class="btn btn-link btn-sm"
            type="button"
            v-on:click="filterData"
            style="width: 60px"
          >
            <i class="fa fa-search"></i>
            Buscar
          </button>
          <button
            class="btn btn-link btn-sm"
            type="button"
            v-on:click="clearFilterData"
            style="width: 30px"
          >
            <i class="fa fa-times"></i>
            Limpiar Datos
          </button>
        </div>
      </div>
      <br />
      <div class="form-inline">
        <input
          class="form-control text-center form-control-sm rounded bright"
          placeholder="Serie"
          v-model="search.cargo_serie"
          type="text"
          style="width: 80px; text-transform: uppercase"
          v-on:keyup.enter="filterData"
        />
        <input
          class="form-control form-control-sm rounded bright"
          placeholder="Nit cliente"
          v-model="search.cliente"
          type="text"
          v-on:keyup.enter="filterData"
          style="width: 100px; text-transform: uppercase"
        />
        <input
          class="form-control form-control-sm rounded bright"
          placeholder="#"
          v-model="search.numero"
          type="text"
          style="width: 75px; text-transform: uppercase"
          v-on:keyup.enter="filterData"
        />
        <input
          type="date"
          v-model="search.fecha"
          style="width: 140px"
          class="form-control form-control-sm rounded bright"
        />
        <select
          class="form-control form-control-sm rounded bright"
          v-model="filtro_tienda"
          @change="filterData"
          style="width: 150px"
        >
          <option value="">Tiendas</option>
          <option
            v-for="data in tiendas"
            :value="data.codigo"
            v-bind:key="data.id"
          >
            {{ data.nombre }}
          </option>
        </select>
        <select
          class="form-control form-control-sm rounded bright"
          v-model="filtro_estado"
          @change="filterData"
          style="width: 108px"
        >
          <option value>Estatus</option>
          <option value="9">Anulado</option>
          <option value="A">Abierto</option>
          <option value="B">Cerrado</option>
          <option value="E">IMPRESA</option>
        </select>
      </div>
    </div>
    <table class="table table-lightborder table-striped table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Nit</th>
          <th>Cliente</th>
          <th>Fecha</th>
          <th>Caja</th>
          <th>Serie</th>
          <th>Monto</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="currentSaldo in data.results"
          v-bind:key="currentSaldo.id"
          @click="rowClick(currentSaldo)"
        >
          <td>{{ currentSaldo.numero }}</td>
          <td>{{ currentSaldo.tienda.nombre }}</td>
          <td>{{ currentSaldo.cliente.nit }}</td>
          <td>{{ currentSaldo.cliente.nombre }}</td>
          <td>{{ currentSaldo.fecha }}</td>
          <td>
            <span v-if="currentSaldo.pedido_e">{{
              currentSaldo.pedido_e.caja
            }}</span>
          </td>
          <td>{{ currentSaldo.cargo_serie.serie }}</td>
          <td>{{ currentSaldo.valor_total }}</td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="currentSaldo.estado_str"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="loading == true" class="content-spin">
      <div class="spin"></div>
    </div>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent
      :currentPage="currentPage"
      :data="data"
      @pagechanged="onPageChange"
    />
    <div
    style="background-color: rgba(2, 2, 2, 0.18)"
      class="modal fade"
      data-toggle="modal"
      data-backdrop="false"
      id="cantidadSaldoModal"
      tabindex="0"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div  class="modal-dialog modal-sm" role="document">
        <div  class="modal-content">
          <div style="background-color: yellowgreen" class="modal-header faded smaller">
            <h6 class="modal-title">Cantidad de saldo</h6>
            <button
              aria-label="Close"
              class="close"
              @click="cerrarModalSaldo"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Saldo</label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentSaldo.valor"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregarSaldo(currentSaldo)">
              Guardar
            </button>
            <button
              class="btn btn-secondary"
              @click="cerrarModalSaldo"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import Notifications from "@/notifications/notifications";

export default {
  props: ["current"],
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      loading: false,
      data: [],
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      searchtext: "",
      filtro_tienda: "",
      search: {},
      tiendas: "",
      cargo_e: {},
      currentSaldo: {
        error: [],
      },
    };
  },
  computed: {},
  mounted() {
    this.refreshTienda();
    this.refreshData();
  },
  methods: {
    cerrarModalSaldo() {
      $("#cantidadSaldoModal").modal("hide");
    },
    onPageChange(page) {
      let self = this;
      this.currentPage = page;
      DynamicService.fetch("cxc", "cargos", {
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      }).then((response) => {
        self.data = response.data;
        this.loading = false;
      });
    },
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas").then((response) => {
        self.tiendas = response.data.results;
      });
    },
    refreshData() {
      let self = this;
      this.loading = true;
      DynamicService.fetch("cxc", "cargos").then((response) => {
        self.data = response.data;
        this.loading = false;
      });
    },
    filterData() {
      this.loading = true;
      this.$data.currentPage = 1;
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }

      DynamicService.fetch("cxc", "cargos", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      })
        .then((response) => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.data = "";
        });
    },
    clearFilterData() {
      this.filtro_tienda = "";
      this.filtro_estado = "";
      this.searchtext = "";
      this.search = {
        cargo_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.$data.currentPage = 1;
      this.filterData();
    },
    rowClick(currentSaldo) {
      let self = this;
      self.cargo_e = currentSaldo;
      $("#cantidadSaldoModal").modal();
    },
    agregarSaldo(currentSaldo) {
      let self = this;
      console.log(this.cargo_e);
      DynamicService.postAction(
        "cxc",
        "linea-credito",
        self.current.id,
        "agregar_saldo",
        {
          valor: currentSaldo.valor,
          cargo_e: this.cargo_e.id,
        }
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar Saldo",
            "Se ha guardado la Información."
          );
          self.$emit("refreshCurrent");
          this.refreshDetalleDefault();
          $("#cantidadSaldoModal").modal("hide");
          self.$emit("cerrarModalDetail");
        })
        .catch((error) => {
          Notifications.alert.error(
            "Agregar Saldo",
            error.response.data.detail
          );
        });
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentSaldo = "";
      self.cargo_e = "";
    },
  },
};
</script>
